(() => {
  const money = (cents) => `$${(cents / 100).toFixed(2)}`;

  function init(builder) {
    if (builder.dataset.initialized === 'true') return;
    builder.dataset.initialized = 'true';

    const form = builder.closest('form[action*="/cart/add"]');
    if (!form) return;
    const error = builder.querySelector('[data-lid-error]');
    const selectedJar = () => builder.querySelector('input[name="wholesale-jar-style"]:checked');
    const selectedLid = () => builder.querySelector('input[name="wholesale-lid-style"]:checked');
    const jarCount = () => {
      const productInfo = builder.closest('[id^="ProductInfo-"]');
      const selected = productInfo?.querySelector('variant-selects input[type="radio"]:checked, variant-selects select option:checked');
      const source = selected?.textContent || selected?.value || '';
      if (/sample/i.test(source)) return 1;
      const match = source.match(/[\d,]+/);
      return match ? Number(match[0].replace(/,/g, '')) : 1;
    };
    const orderQuantity = () => Number(document.querySelector(`[form="${CSS.escape(form.id)}"][name="quantity"]`)?.value || form.querySelector('[name="quantity"]')?.value || 1);

    function update() {
      const jar = selectedJar();
      const lid = selectedLid();
      const feeCents = Number(lid?.dataset.feeCents || 0);
      builder.querySelector('[data-jar-property]').value = jar?.value || '';
      builder.querySelector('[data-lid-property]').value = lid?.value || '';
      builder.querySelector('[data-packaging-selection]').textContent = jar && lid ? `${jar.value} + ${lid.value}` : 'Choose your packaging';
      builder.querySelector('[data-lid-price]').textContent = money(feeCents * jarCount() * orderQuantity());
      error.hidden = true;
      return { jar, lid, feeCents };
    }

    builder.addEventListener('change', update);
    document.addEventListener('change', (event) => {
      if (event.target.matches('variant-selects select, variant-selects input, [name="quantity"]')) update();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const selection = update();
      if (!selection.jar || !selection.lid) {
        error.textContent = 'Please choose a jar and lid style.';
        error.hidden = false;
        return;
      }

      const button = form.querySelector('[type="submit"]');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');

      const values = Object.fromEntries(new FormData(form));
      const mainQuantity = orderQuantity();
      const properties = {};
      new FormData(form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      });
      const bundleId = window.crypto?.randomUUID?.() || `packaging-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      properties._custom_salve_bundle = bundleId;
      const items = [{ id: Number(values.id), quantity: mainQuantity, properties }];
      if (selection.feeCents > 0) {
        const feeVariantId = Number(builder.dataset.feeVariantId);
        const feeUnitCents = Number(builder.dataset.feeUnitCents);
        items.push({
          id: feeVariantId,
          quantity: (selection.feeCents / feeUnitCents) * jarCount() * mainQuantity,
          properties: {
            _custom_salve_parent: String(values.id),
            _custom_salve_bundle: bundleId,
            _packaging_upgrade: selection.lid.value,
          },
        });
      }

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this item to the cart.');
        window.location = window.routes.cart_url;
      } catch (exception) {
        error.textContent = exception.message;
        error.hidden = false;
      } finally {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
    }, true);

    update();
  }

  const boot = () => document.querySelectorAll('[data-wholesale-lid-builder]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
